<h1 mat-dialog-title>Phone Number Search</h1>
<div mat-dialog-content class="phone-search-pop">
    
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <span>Phone Number: </span><label id="phoneNumber">{{_data?.phoneNumber}}</label>
        </div>
        <div class="col-md-6 col-sm-12">
            <span>Elevator Id: </span><label id="elevatorId">{{_data?.elevatorId}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <span class="building-label">Building: </span><br /><label id="buildingName">{{_data?.buildingName}}</label><br /><label id="buildingAddress">{{_data?.buildingAddress}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <span class="map-label">Map: </span><br />
            <div #phonenumbersearchmap id="phonenumbersearchmap" style="height: 200px;"></div>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button id="closeButton" class="reset_bg" (click)="onDialogCancel()">Cancel</button>
</div>